import { useEffect, useState } from 'react';
import { UniversalLink } from '@plone/volto/components';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faXTwitter, faWhatsapp, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { addAppURL } from '@plone/volto/helpers';

const ShareBar = props => {

    const content = useSelector((state) => state.content.data);
    const url = content ? addAppURL(content?.['@id'] || '/') : null;

    return (
        <>
            <div className='d-flex bt-1 border-top pt-4 gap-3 align-items-center flex-wrap mt-5 d-print-none'>
                <Button primary onClick={() => window.print()} basic type='button' className='border-0'>
                    <span className="fs-6">
                        <FontAwesomeIcon icon={faPrint} className='me-2' />
                        <FormattedMessage id="Print" defaultMessage="Print" />
                    </span>
                </Button>
            
                {url ? (
                    <div className='ms-auto d-flex align-items-center'>
                        <span className='me-2' ><FormattedMessage id="Share" defaultMessage="Share" /></span>
                        <div className='d-flex gap-3'>
                            <a className='shareButtons__link' href={'https://www.facebook.com/sharer/sharer.php?u=' + url} >
                                <FontAwesomeIcon icon={faFacebookF} className='fs-4' /><span className="visually-hidden"><FormattedMessage id="Share on Facebook" defaultMessage="Share on Facebook" /></span>
                            </a>
                            <a className='shareButtons__link' href={'https://twitter.com/share?url=' + url} >
                                <FontAwesomeIcon icon={faXTwitter} className='fs-4' /><span className="visually-hidden"><FormattedMessage id="Share on X" defaultMessage="Share on X" /></span>
                            </a>
                            <a className='shareButtons__link' href={'https://api.whatsapp.com/send?text= ' + url} >
                                <FontAwesomeIcon icon={faWhatsapp} className='fs-4' /><span className="visually-hidden"><FormattedMessage id="Share on Whatsapp" defaultMessage="Share on Whatsapp" /></span>
                            </a>
                            <a className='shareButtons__link' href={'http://www.linkedin.com/shareArticle?mini=true&amp;url=' + url} >
                                <FontAwesomeIcon icon={faLinkedinIn} className='fs-4' /><span className="visually-hidden">Linkedin</span>
                            </a>
                        </div>
                    </div>
                ) : null}
            </div>
        </>
    );
};

export default ShareBar;